import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

import UserStore from '../stores/UserStore'
import initialize from '../utils/general/initialize'
import LoadingIndicator from '../components/atoms/loadingIndicator'
import MainComponent from '../components/templates/mainComponent'

dayjs.extend(isSameOrAfter)

let visibilityChange
if (typeof document.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  visibilityChange = 'visibilitychange'
} else if (typeof document.msHidden !== 'undefined') {
  visibilityChange = 'msvisibilitychange'
} else if (typeof document.webkitHidden !== 'undefined') {
  visibilityChange = 'webkitvisibilitychange'
}

const MainScreen = observer(() => {
  useEffect(() => {
    UserStore.setIsLoaded(true)
  }, [])

  useEffect(() => {
    const loadOnVisibilityChange = async () => {
      if (document.visibilityState === 'visible') {
        setTimeout(async () => {
          UserStore.setIsLoaded(false)
          await initialize.loadBasicInfo()
          UserStore.setIsLoaded(true)
        }, 500)
      }
    }

    document.addEventListener(visibilityChange, loadOnVisibilityChange, false)
    return () => {
      document.removeEventListener(visibilityChange, loadOnVisibilityChange)
    }
  }, [])

  if (!UserStore.isLoaded) {
    return <LoadingIndicator isLoading />
  }
  return <MainComponent />
})

export default MainScreen
